import { isAppPage } from "./helper/pages";

angular.module('cfn').run(appRun);

appRun.$inject = [
  '$rootScope',
  '$location',
  '$dialog',
  '$injector',
  'TermsAcceptanceService',
  'moduleLoading',
  'error-message.service'
];

function appRun(
  $rootScope,
  $location,
  $dialog,
  $injector,
  TermsAcceptanceService,
  moduleLoading,
  errorMessageService
) {
  init();

  app.showTicketDialog = showTicketDialog;
  app.openPopup = openPopup;

  function init() {
    // Check if user should accept new terms
    TermsAcceptanceService.check();
  }

  function showTicketDialog(errorMessage, exceptionDetails) {
    var message = errorMessage;
    if (!message) {
      message = i18n(
        'fe.admin.ticket.sendTicket.message.default',
        'unbekannter Fehler'
      );
    }

    var $location = $location || $injector.get('$location');
    errorMessageService.reportException({
      message: message,
      cause: exceptionDetails,
      context: $location.path()
    });
  }

  function openPopup(resolve, templateUrl, controllerName, resultFunc) {
    var modalInstance = $dialog
      .dialog({
        resolve: resolve
      })
      .open(templateUrl, controllerName)
      .then(resultFunc);
  }
}
